<template>
    <broadcast-card eyebrow="Πριν τον αγώνα" title="Μέσοι όροι σεζόν">
        <broadcast-compare :sides="sides" :rows="rows" />
    </broadcast-card>
</template>

<script>
    import BroadcastCard from '@/components/BroadcastCard'
    import BroadcastCompare from '@/components/BroadcastCompare'
    import { BACKGROUNDS, getMatchColors } from '@/utils/colors'

    const ASSETS_URL = 'https://storage.googleapis.com'

    const STATS = [
        { key: 'points', label: 'Πόντοι' },
        { key: 'two', label: 'Δίποντα', made: 'twoPointsMade', attempts: 'twoPointAttempts' },
        { key: 'three', label: 'Τρίποντα', made: 'threePointsMade', attempts: 'threePointAttempts' },
        { key: 'free', label: 'Βολές', made: 'freeThrowsMade', attempts: 'freeThrowAttempts' },
        { key: 'offensiveRebounds', label: 'Επιθετικά ριμπάουντ' },
        { key: 'defensiveRebounds', label: 'Αμυντικά ριμπάουντ' },
        { key: 'assists', label: 'Ασίστ' },
        { key: 'steals', label: 'Κλεψίματα' },
        { key: 'blockedShots', label: 'Κοψίματα' },
        { key: 'turnovers', label: 'Λάθη', lowerIsBetter: true },
        { key: 'pir', label: 'PIR' }
    ]

    // Pregame: the two teams' per-game averages this season
    export default {
        name: 'TeamComparison',
        components: { BroadcastCard, BroadcastCompare },
        props: {
            match: {
                type: Object,
                default: () => ({})
            },
            team1: {
                type: Object,
                default: () => ({})
            },
            team2: {
                type: Object,
                default: () => ({})
            }
        },
        computed: {
            colors() {
                return getMatchColors(this.match.team1, this.match.team2, BACKGROUNDS.dark)
            },
            sides() {
                return ['team1', 'team2'].map((key) => {
                    const team = this.match[key] || this[key] || {}
                    const record = this[key] || {}
                    const won = Number(record.seasonWins) || 0
                    const lost = Number(record.seasonLoses) || 0
                    return {
                        name: team.name || record.name,
                        sub: won + lost ? `${won} νίκες · ${lost} ήττες` : '',
                        logo: team.logo ? `${ASSETS_URL}/${team.logo}` : null,
                        color: this.colors[key]
                    }
                })
            },
            // every player's every game added up, and the number of games the team played
            totals() {
                return ['team1', 'team2'].map((key) => {
                    const team = this[key] || {}
                    const totals = {}
                    ;(team.players || []).forEach((player) => {
                        (player.stats || []).forEach((game) => {
                            Object.keys(game || {}).forEach((field) => {
                                if (typeof game[field] === 'number') totals[field] = (totals[field] || 0) + game[field]
                            })
                        })
                    })
                    totals.games = (Number(team.seasonWins) || 0) + (Number(team.seasonLoses) || 0)
                    return totals
                })
            },
            rows() {
                const [t1, t2] = this.totals
                return STATS.map((stat) => {
                    if (stat.made) {
                        const pct = totals => (totals[stat.attempts] ? Math.round(totals[stat.made] / totals[stat.attempts] * 1000) / 10 : 0)
                        const a = pct(t1)
                        const b = pct(t2)
                        return { key: stat.key, label: stat.label, value1: a, value2: b, display1: `${a.toFixed(1)}%`, display2: `${b.toFixed(1)}%` }
                    }
                    const avg = totals => (totals.games ? Math.round((totals[stat.key] || 0) / totals.games * 10) / 10 : (totals[stat.key] || 0))
                    const a = avg(t1)
                    const b = avg(t2)
                    return { key: stat.key, label: stat.label, value1: a, value2: b, display1: a.toFixed(1), display2: b.toFixed(1), lowerIsBetter: stat.lowerIsBetter }
                })
            }
        }
    }
</script>
